import { IconCheck, IconUser } from "@tabler/icons-react";
import { Avatar } from "@mantine/core";
import type { Member } from "../../../../types/members";

const SelectOption = ({
  avatar,
  firstName,
  lastName,
  selected,
}: Omit<Member, "status"> & { selected: boolean }) => {
  const name = firstName + " " + lastName;
  return (
    <button className="option-container">
      {avatar || (
        <Avatar bg="gray">
          <IconUser size={18} color="white" />
        </Avatar>
      )}
      <div className="option-text-container">
        <div className="option-text">{name}</div>
      </div>
      {selected && <IconCheck size={12} className="option-check" />}
    </button>
  );
};

export default SelectOption;
